import React from "react";
import { Flex } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { RiskRating } from "../../../graphql/supergraphEnums";
import { RiskRating as RiskRatingType } from "../../../graphql/supergraphTypes";
import { RiskRatingBadge } from "../RiskRatingBadge";
import { riskRatingGridCellBase, riskRatingGridCellDanger } from "./styles_vanilla.css";

export type RiskRatingGridCellProps = {
  rating: RiskRatingType;
};

const isDangerRating = (rating: RiskRatingType): boolean =>
  rating === RiskRating.High || rating === RiskRating.Halt;

export const RiskRatingGridCell = ({ rating }: RiskRatingGridCellProps) => {
  const containerClass = isDangerRating(rating)
    ? `${riskRatingGridCellBase} ${riskRatingGridCellDanger}`
    : riskRatingGridCellBase;

  return (
    <Flex
      alignItems="center"
      gap={Sizes.XS}
      className={containerClass}
      data-testid="risk-rating-grid-cell"
    >
      <RiskRatingBadge rating={rating} textVariant="strong-md" iconSize="small" />
    </Flex>
  );
};
